import { Link } from "react-router-dom";
import Button from "../../UI/Button/Button";
import TextSketch from "./images/textsketch.svg";
import "./TopLHS.css";

const APPOINTMENT_URL =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1uHmQd3vieliyTtHcA_U4Zzs9Si9Evo12FkwP2oYQWihGVDxU_wJYh6J6YZKK8NC9Ha0MoRyQ6";

const TopLHS = () => {
  return (
    <div className="uigrid-6 top-lhs">
      <div className="lhs-inner">
        <div className="header-text">
          <h1>We build software</h1>
          <h1>that scales</h1>
          <div className="header-text-sketch">
            <img src={TextSketch} alt="" />
          </div>
        </div>
        <div className="header-description">
          <p>
            Awa Digital develops and operates ordering, payments, and operations
            software for restaurants, cloud kitchens, and merchants in Nigeria
            and the UK.
          </p>
        </div>

        <div className="header-links">
          <Button
            value="Book an appointment"
            class="header-link-btn"
            href={APPOINTMENT_URL}
          />
          <p className="header-links-more">
            <Link to="/platform" className="header-see-more hoverable">
              See what we build
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TopLHS;
